const createContent = (data) => ({
  headers: { 'content-type': 'application/json' },
  body: JSON.stringify(data),
  method: 'POST'
})

export default createContent
